import { Box, styled } from '@mui/material';

/** 레거시 마크업 class 보충 — 상세표는 열 폭 합이 넓어 표마다 가로 스크롤 */
export const SapBondStatusRoot = styled(Box)`
  /* 레거시 문서 content 의 fieldset 은 기본 min-width 로 표 폭만큼 늘어나 화면을 넘침 */
  & fieldset {
    min-width: 0;
    margin: 0;
    padding: 0;
    border: 0;
  }
  /* 공통 표의 break-all 보다 우선해야 영문 머리글이 단어 중간에서 안 끊김 */
  & .approval-form-table th {
    word-break: keep-all;
  }
  & section + section {
    margin-top: 16px;
  }
  & .text-center td,
  & .text-center th,
  & .text-center {
    text-align: center;
  }
  & th.text-left,
  & td.text-left {
    text-align: left;
  }
`;
